import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizBasePopUp,
  WizDatasource,
  WizRoot,
  WizEventManager, WizEvent, WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { FunctionObj, FunctionCoreEngine } from '@wizeoo/akm-compute-lib';
import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MultiDisplayConfig } from '../../multi-display/config/multi-display.config';
import { AddFunctionRenderer } from './compos/add-function.renderer';
import { ALK_EVENT_TYPE } from '../../../model/enums';
import { AlkEvent } from '../../../framework/events/alk.event';
import { Model } from '../../../model/model';
import { MeasureParams } from '../../../manager/workingdata/measure.engine';

@Component({
  // popup de construction des functions
  selector: 'add-function-pop',
  templateUrl: './add-function.pop.html',
})
export class AddFunctionPop extends WizBasePopUp implements AfterViewInit {
  
  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {

    
    if (event.key === VALUE_ENTER) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.doCancel();
    }
  }  
  
  @ViewChild('functionFilter', { read: FilterComponent }) functionFilter: FilterComponent; // filtre des functions
  @ViewChild('descDiv') descDiv: ElementRef; // la div de détail des formules / fonctions

  protected doSaveFlag: boolean = false; // marqueur de validation des modifs (false sur cancel)
  
  private _model : Model = null;
  public get model(): Model {
    return this._model;
  }

  public mode: string; // le mode choisi (FIST)
  public source: FunctionObj = null; // la fonction d'origine
  protected updateCallback: Function; // la callback pour retour et traitement

  public currentFunction: FunctionObj;
  public functionDS: WizDatasource<FunctionObj> = new WizDatasource<FunctionObj>([])
    .setItemCodeField('code')
    .setSelectionMode('single')
    .setFilter(this.functionFilterFunc.bind(this))
    .setSortFields([{ property: 'label', way: 'asc', numeric: false }])
    .build(); // la collection de fonctions disponibles

  public currentDescHtml: SafeHtml = ''; // le contenu de la div de description

  /** Affichage des applications */
  public tileDisplayConfig: MultiDisplayConfig<FunctionObj> = {
    model: this.model,
    datasource: this.functionDS,
    defaultMode: 'tiles',
    onSelectionChanging: this.onSelectionChanging.bind(this),
    onSelectionChanged: this.showDesc.bind(this),
    tiles: {
      enabled: true,
      renderer: AddFunctionRenderer,
      itemHeight: 70,
      itemWidth: 200,
    },
  };

  constructor(public elementRef: ElementRef, private sanitizer: DomSanitizer) {
    super();
  }

  ngAfterViewInit(): void {
    let params: MeasureParams = this.datas;
    // TODO TODO this.source = params.measure;
    this.mode = params.mode;
    this._model = params.model;
    this.updateCallback = params.callback;
    
    setTimeout(() => {
      this.feed();
      this.addListeners();
    }, 0);
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.functionFilter, WIZ_EVENT_TYPE.FILTER, this.doFilterFunction); // ecouteur sur le filtre des functions
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_QUICK_SELECT, this.save); // 2x clic sur le header d'un renderer
  }

  /**
   * demande de changement de sélection depuis le multi display
   * @param e wizEvent contenant l'item sélectionné
   */
  private onSelectionChanging(e: WizEvent = null): void {
    // pas de désélection d'un item
    if (this.functionDS.isSelected(e.value)) {
      e.preventDefault();
      return;
    }
  }

  private showDesc(e: WizEvent): void {
    if ((e.value as any).length <= 0) {
      // console.log('nope');
      this.currentDescHtml = this.sanitizer.bypassSecurityTrustHtml('');
      this.currentFunction = null;
    } else {
      const htmlParts: string[] = []; // les lignes pour la construction de la description

      this.currentFunction = e.value[0] as FunctionObj;
      htmlParts.push('<span class="smallTitleLabel">' + this.currentFunction.code + '(</span>');

      const params: string[] = []; // gestion des paramètres
      this.currentFunction.parameters.forEach((param: string) => {
        // TODO gérer la configuration alternative
        params.push(
          '<span>' +
            WizTranslationManager.getInstance().translateKey('$.function.parameter.' + param + '.$') +
          '</span>'
        );
      });
      if (this.currentFunction.unlimitedParameters) {
        params.push('<span>...</span>');
      }
      htmlParts.push(params.join('<span class="componentLabel">;</span>'));

      htmlParts.push('<span class="componentLabel">)</span></br>');
      htmlParts.push('<span>' + this.currentFunction.getDescription() + '</span>');

      this.currentDescHtml = this.sanitizer.bypassSecurityTrustHtml(htmlParts.join(''));
    }
  }

  /** alimentation des composants */
  private feed(): void {
    // construction du filtre des fonctions disponibles
    this.functionFilter.configure(['label', 'code'], null, null).build();
    // alimentation de la liste des fonctions
    const funcArray: FunctionObj[] = Array.from(FunctionCoreEngine.functionMap(this.model).values());
    // On rajoute un label traduit pour le filtre et le tri
    funcArray.forEach(func => func['label'] = func.getLabel());
    this.functionDS.setSource(Array.from(FunctionCoreEngine.functionMap(this.model).values()));
  }

  // filterFunc de la collection de fonctions
  protected functionFilterFunc(item: FunctionObj): boolean {
    return this.functionFilter.checkVisible(item);
  }

  /* modification du filtre des fonctions
   * @param e WizEvent
   */
  protected doFilterFunction(e: WizEvent): void {
    this.functionDS.refresh();
  }

  /** validation du contenu */
  public save(e: AlkEvent = null): void {
    // this.doSaveFlag = true;
    this.updateCallback(this.currentFunction);
    // this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.updateCallback(null);
    this.hide();
  }

}
